/**
@format
@flow
*/
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

type Props = $ReadOnly<{|
  history: {
    listen: (()=> void) => void,
  }
|}>;

function ScrollToTop(props: Props) {
  const { history } = props;
  useEffect(() => {
    const unlisten = history?.listen(() => {
      window.scroll({ top: 0, left: 0, behavior: 'auto' });
    });
    return () => {
      if (!unlisten) return undefined;
      unlisten();
    };
  }, []);

  return (null);
}

export default (withRouter(ScrollToTop): any);
